import { v4 } from 'uuid';

import { AdditionServicesState } from '../types';

/**
 * Дефолтный стейт доп. услуг.
 */
export class DefaultAdditionServicesState implements AdditionServicesState {
  IsRestoringState = true;
  RootServices = [];
  ServicesPath = {};
  IsLastLevelSelected = false;
  IsLoadingDirectoriesForPath = false;
  LoadedDirectoriesCache = {};
  LastServiceInPath = undefined;
  FieldsToDisplay = [];
  FieldValues = {};
  IsNeedCalculateServices = false;
  IsServicesLoading = false;
  Variants = [];
  SelectedVariant = '';
  SelectedProductUUID = v4();
  VariantServices = {};
  VariantFields = {};
  VariantFieldValues = {};
  VariantSelectedServices = {};
  IsServicesCalculating = false;
  LastServiceCalculationID = '';
  ServiceTemplateStore = {};
  CurrencyID = '';
  LanguageID = '';
  VariantsCalculationResult = {};
  VariantProperties = {};
  PropertyValues = {};
  PropertiesToDisplay = [];
}
